import React, { useState, useEffect, useCallback } from "react";
import { CancelRequest } from "../../../services/AxiosInstance";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Pagination from "../../constant/Pagination";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import TableLoaderEffect from "../../constant/TableLoader";
import DebounceSearchInput from "../../constant/DebounceSearchInput";
import { getMeasurmentSheetListApi } from "../../../services/DocumentService";
import VersionStatus from "./VersionStatus";
import { StaticSelectInput } from "../../constant/SelectInput";

const TESheetPage = ({ userPermission }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [query, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({ status: "" });
  const [isLoading, setIsLoading] = useState(false);
  const recordsPerPage = 25;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  useEffect(() => {
    if (status) {
      setFilter((prev) => ({ ...prev, status }));
      setCurrentPage(1);
      navigate("/te-sheet", { replace: true });
    }
  }, [status, navigate]);

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getMeasurmentSheetListApi(currentPage, recordsPerPage, query, filter.status)
      .then((resp) => {
        setData(resp.data.data);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, query, filter.status]);

  useEffect(() => {
    fetchData();
  }, [fetchData, status]);

  const handleShowParameters = (parameters) => {
    setSelectedParameters(parameters);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedParameters([]);
  };

  const handleSearchChange = (value) => {
    CancelRequest();
    setSearchQuery(value);
    setCurrentPage(1);
  };

  const handleSelectChange = (name, value) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleAfterUpdate = (updatedData) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === updatedData.id ? { ...item, ...updatedData } : item
      )
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-header">
                  <h3 className="mb-0">TE-Sheet List</h3>
                  <div className="table-left-header d-flex align-items-center">
                    <div className="me-3 mt-3">
                      <StaticSelectInput
                        optionsList={[
                          { label: "Pending", value: "pending" },
                          { label: "Approved", value: "approved" },
                          { label: "Rejected", value: "rejected" },
                        ]}
                        setParentInputValue={handleSelectChange}
                        name="status"
                        isClearable
                        placeholder="Select Status"
                      />
                    </div>
                    <div className="form-group me-3">
                      <DebounceSearchInput
                        handleSearchChange={handleSearchChange}
                      />
                    </div>
                    {userPermission.create && (
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          navigate("/add-sheet");
                        }}
                      >
                        Add Sheet
                      </button>)}
                  </div>
                </div>

                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <table
                    id="empoloyees-tblwrapper"
                    className="table ItemsCheckboxSec dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Document</th>
                        <th>Parameter</th>
                        <th>Created By</th>
                        <th>Approved By</th>
                        <th>Issued By</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <TableLoaderEffect colLength={7} />
                      ) : (
                        data.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <span
                                className="text-primary fw-bold c-pointer"
                                onClick={() => navigate(`/te-sheet/${item.id}`)}
                              >
                                {item?.title}
                              </span>
                            </td>
                            <td>

                              <Link to={`/document/${item.document.id}`} >{item.document.title}</Link>
                            </td>
                            <td>
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() =>
                                  handleShowParameters(item.parameters)
                                }
                              >
                                Parameters ({item.parameters.length})
                              </span>
                            </td>
                            <td>
                              <div className="d-flex flex-column">
                                <strong>
                                  {item?.created_by?.name}{" "}
                                </strong>
                                <span>{item?.created_by?.created_at}</span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex flex-column">
                                <strong>
                                  {item?.approved_by?.name}{" "}
                                </strong>
                                <span>{item?.approved_by?.approved_at}</span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex flex-column">
                                <strong>
                                  {item?.issued_by?.name}{" "}
                                </strong>
                                <span>{item?.issued_by?.issued_at}</span>
                              </div>
                            </td>
                            <td>
                              <VersionStatus
                                item={item}
                                handleAfterUpdate={handleAfterUpdate}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {isLoading ? (
                  <div style={{ height: "4rem" }}></div>
                ) : (
                  <Pagination
                    currentPage={currentPage}
                    recordsPage={recordsPerPage}
                    dataLength={total}
                    handlePagination={handlePagination}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} size="sm" onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Parameter Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <table
              id="empoloyees-tblwrapper"
              className="table ItemsCheckboxSec dataTable no-footer mb-0"
            >
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Expected Value</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <TableLoaderEffect colLength={5} />
                ) : (
                  selectedParameters.map((param, index) => (
                    <tr key={index}>
                      <td>{param.parameter_name}</td>
                      <td>{param.expected_value}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => ({
  userPermission: state.auth.user?.test_evaluation_permission,
  user: state.auth.user,
});
export default connect(mapStateToProps)(TESheetPage);
